export const DisabledCell = () => {
	return <div className="absolute inset-0 !p-0 bg-input-disabled" />
}
